import loading from 'reducers/loading'
import prospect from 'reducers/prospect'
import system from 'reducers/system'
import jointOwners from 'reducers/jointOwners'
import financialAccounts from 'reducers/financialAccounts'
import contacts from 'reducers/contacts'
import contactFinancialAccountRoles from 'reducers/contactFinancialAccountRoles'
import reciprocalRoles from 'reducers/reciprocalRoles'
import sidebar from 'reducers/sidebar'
import modals from 'reducers/modals'
import teamMembers from 'reducers/client/teamMembers'
import documents from 'reducers/client/documents'
import user from 'reducers/client/user'
import investmentPlans from 'reducers/client/investmentPlans'
import primaryPortfolioClassAllocations from 'reducers/client/primaryPortfolioClassAllocations'
import primaryPortfolio from 'reducers/client/primaryPortfolio'
import primaryPortfolioAccounts from 'reducers/client/primaryPortfolioAccounts'
import primaryPortfolioHoldings from 'reducers/client/primaryPortfolioHoldings'
import mobileNav from 'reducers/client/mobileNav'
import clientErrors from 'reducers/client/errors'
import clientLoading from 'reducers/client/loading'
import redirection from 'reducers/client/redirection'
import notifications from 'reducers/client/notifications'
import contactRelationships from 'reducers/contactRelationships'
import contactTypes from 'reducers/contactTypes'

export default {
  loading,
  prospect,
  system,
  jointOwners,
  contacts,
  financialAccounts,
  sidebar,
  modals,
  user,
  primaryPortfolio,
  teamMembers,
  investmentPlans,
  primaryPortfolioAccounts,
  primaryPortfolioClassAllocations,
  primaryPortfolioHoldings,
  documents,
  ...clientErrors,
  ...clientLoading,
  redirection,
  mobileNav,
  notifications,
  contactFinancialAccountRoles,
  reciprocalRoles,
  contactRelationships,
  contactTypes
}



// WEBPACK FOOTER //
// ./src/reducers/index.js